<template>
  <!-- Временная отладочная версия для диагностики -->
  <div class="notification-item-debug" :style="debugStyle">
    <strong>{{ notification.type.toUpperCase() }}:</strong> {{ notification.message }}
    <button @click="onDismiss" style="float: right; background: none; border: none; font-size: 18px; cursor: pointer;">
      ×
    </button>
  </div>
</template>

<script>
export default {
  name: 'NotificationItem',
  props: {
    notification: {
      type: Object,
      required: true
    },
    showIcon: {
      type: Boolean,
      default: true
    },
    showTimestamp: {
      type: Boolean,
      default: false
    },
    showProgressBar: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      show: true
    }
  },
  computed: {
    debugStyle() {
      const colors = {
        success: { background: '#d4edda', border: '2px solid #28a745' },
        error: { background: '#f8d7da', border: '2px solid #dc3545' },
        warning: { background: '#fff3cd', border: '2px solid #ffc107' },
        info: { background: '#d1ecf1', border: '2px solid #17a2b8' }
      }
      const typeColors = colors[this.notification.type] || colors.info
      
      return {
        ...typeColors,
        margin: '5px',
        padding: '15px',
        borderRadius: '5px',
        position: 'relative'
      }
    },
    alertVariant() {
      const variants = {
        success: 'success',
        error: 'danger',
        warning: 'warning',
        info: 'info'
      }
      return variants[this.notification.type] || 'info'
    },
    iconName() {
      const icons = {
        success: 'check-circle-fill',
        error: 'exclamation-triangle-fill',
        warning: 'exclamation-triangle-fill',
        info: 'info-circle-fill'
      }
      return icons[this.notification.type] || 'info-circle-fill'
    },
    iconVariant() {
      const variants = {
        success: 'success',
        error: 'danger',
        warning: 'warning',
        info: 'info'
      }
      return variants[this.notification.type] || 'info'
    }
  },
  methods: {
    onDismiss() {
      this.show = false
      this.$emit('dismiss', this.notification.id)
    },
    formatTime(timestamp) {
      const date = new Date(timestamp)
      return date.toLocaleTimeString('ru-RU', { 
        hour: '2-digit', 
        minute: '2-digit' 
      })
    }
  }
}
</script>

<style scoped>
.notification-item {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: none;
  border-radius: 6px;
  position: relative;
  overflow: hidden;
}

.notification-icon {
  flex-shrink: 0;
  margin-top: 2px;
}

.notification-content {
  min-width: 0;
}

.notification-message {
  font-size: 14px;
  line-height: 1.4;
  word-wrap: break-word;
}

.notification-time {
  font-size: 11px;
  margin-top: 4px;
  display: block;
}

.notification-progress {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 3px;
  background-color: rgba(255, 255, 255, 0.3);
}

.notification-progress-bar {
  height: 100%;
  background-color: rgba(255, 255, 255, 0.7);
  animation: shrink linear forwards;
  transform-origin: left;
}

@keyframes shrink {
  from {
    transform: scaleX(1);
  }
  to {
    transform: scaleX(0);
  }
}

/* Дополнительные стили для разных типов уведомлений */
.alert-success .notification-progress-bar {
  background-color: rgba(255, 255, 255, 0.8);
}

.alert-danger .notification-progress-bar {
  background-color: rgba(255, 255, 255, 0.8);
}

.alert-warning .notification-progress-bar {
  background-color: rgba(0, 0, 0, 0.2);
}

.alert-info .notification-progress-bar {
  background-color: rgba(255, 255, 255, 0.8);
}
</style>